export function selectNewSliderSequence(state, payload) {
  return {
    ...state,
    currentChapter: setSliderValueInCurrentChapter(
      state.currentChapter,
      payload
    ),
  };
}

function setSliderValueInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: setDropdownValueInComponents(
      currentChapter.components,
      payload
    ),
  };
}

function setDropdownValueInComponents(components, payload) {
  return components.map((component) => {
    if (component.id === payload.componentID) {
      component = setSliderValueInDNDQComponent(component, payload);
    }
    return component;
  });
}

function setSliderValueInDNDQComponent(dndqComponent, payload) {
  const setValueInSlider = (slider) => {
    const updatedSlider = {...slider};
    if (updatedSlider.id === payload.sliderID) {
      updatedSlider.current = payload.current;
      updatedSlider.updated = true;
    }
    return updatedSlider;
  };

  return {
    ...dndqComponent,
    showFeedback: false,
    sliders: dndqComponent.sliders.map(setValueInSlider),
  };
}
